import React from 'react';
import Fade from 'react-reveal/Fade';
import Map from './map';

const ContactMap = ({googleMap}) => {
  return (
    <section className="contact-map">
      <div className="contact-map__inner">
        <Fade>
          <Map lat={googleMap?.latitude} lng={googleMap?.longitude} />
        </Fade>
      </div>
    </section>
  );
}

export default ContactMap